import { render, staticRenderFns } from "./StudentMedicalInfo.vue?vue&type=template&id=568a0af1&scoped=true"
import script from "./StudentMedicalInfo.vue?vue&type=script&lang=js"
export * from "./StudentMedicalInfo.vue?vue&type=script&lang=js"
import style0 from "./StudentMedicalInfo.vue?vue&type=style&index=0&id=568a0af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568a0af1",
  null
  
)

export default component.exports